import React from 'react';

const VideoCall = () => {
  const [isWaiting, setIsWaiting] = React.useState(true);
  const [localStream, setLocalStream] = React.useState<MediaStream | null>(null);
  const localVideoRef = React.useRef(null);

  React.useEffect(() => {
    const getLocalStream = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
        setLocalStream(stream);
      } catch (error) {
        console.error('Error accessing webcam:', error);
      }
    };

    getLocalStream();

    return () => {
      if (localStream) {
        (localStream as MediaStream).getTracks().forEach(track => track.stop());
      }
    };
  }, []);

  React.useEffect(() => {
    if (localStream && localVideoRef.current) {
      (localVideoRef.current as HTMLVideoElement).srcObject = localStream;
    }
  }, [localStream]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      {isWaiting ? (
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">Waiting for the teacher to join...</h1>
          <p className="text-xl text-gray-600">Please wait in the lobby until your teacher arrives.</p>
          <button
            className="mt-8 px-6 py-3 bg-blue-500 text-white rounded-md hover:bg-blue-600"
            onClick={() => setIsWaiting(false)}
          >
            Join Now
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-white p-4 rounded-md shadow-md">
            <video ref={localVideoRef} className="w-full h-auto" autoPlay muted playsInline></video>
            <h2 className="mt-2 text-xl font-semibold">Student</h2>
          </div>
          <div className="bg-white p-4 rounded-md shadow-md">
            <video className="w-full h-auto" src="teacher-video.mp4" autoPlay muted></video>
            <h2 className="mt-2 text-xl font-semibold">Teacher</h2>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoCall;